<div #aboutContainer class="about-container" id="sobre-mi" [class.visible]="isVisible">
  <!-- Sidebar integrada: aparece solo al llegar a esta seccion -->
  <div class="about-sidebar" [class.visible]="isVisible">
    <app-header class="aboutme-sidebar"></app-header>
  </div>

  <div class="about-main">
    <!-- IZQUIERDA: Texto -->
    <div #aboutLeft class="about-left" [class.visible]="isVisible">
      <h2 class="section-title">CEO de <br> BIEN-ESTAR</h2>
      <p class="about-text">
        Soy Natalia Güechá, magíster en psicología clínica y especialista en intervención
        psicológica en situaciones de crisis, bajo una modalidad principalmente virtual e
        híbrida. Mi objetivo es transformar la experiencia clínica tradicional en un
        proceso cercano, dinámico y libre de juicios. He diseñado un ecosistema
        terapéutico pensado para la comunidad global.
      </p>
      <!-- Hobbies -->
      <div class="hobbies">
        <h3 class="hobbies-title">Hobbies</h3>
        <div class="hobbies-bubbles">
          <div class="bubble"><i class="fas fa-book"></i> Leer</div>
          <div class="bubble"><i class="fas fa-moon"></i> Tener tiempo a solas</div>
          <div class="bubble"><i class="fas fa-dumbbell"></i> Hacer ejercicio</div>
          <div class="bubble"><i class="fas fa-people-roof"></i> Tiempo de calidad en familia</div>
        </div>
      </div>

    </div>

    <!-- DERECHA: Carrusel vertical / horizontal responsive -->
    <div #aboutRight class="about-right" [class.visible]="isVisible">
      <div #achievementsViewport class="achievements-viewport">
        <div #achievementsTrack class="achievements-track">
          <!-- La segunda copia solo sirve para el bucle infinito: se oculta a los lectores de pantalla -->
          <div *ngFor="let logro of logrosDuplicados; let i = index" class="achievement-card"
            [attr.aria-hidden]="i >= logros.length ? 'true' : null">
            <img class="achievement-image" [src]="logro.image" [alt]="logro.alt" decoding="async">
          </div>
        </div>
      </div>
    </div>
  </div>

</div>